import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { Module, ReportingRequestType, useGetAccountQuery, useListReportingRequestsQuery } from '~/types/types';
import { useVentureId } from '~/functions/accounts';
import { reportingEsgChipStatus } from '~/functions/reporting';
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeSummary',
  setup: function setup(__props) {
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var ventureId = useVentureId();
    var _useGetAccountQuery = useGetAccountQuery(computed(function () {
        return {
          id: ventureId.value
        };
      })),
      accountResult = _useGetAccountQuery.result;
    var hasMetricsModule = computed(function () {
      var _accountResult$value, _accountResult$value$;
      return (((_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : (_accountResult$value$ = _accountResult$value.getAccount) === null || _accountResult$value$ === void 0 ? void 0 : _accountResult$value$.bookedModules) || []).includes(Module.Metrics);
    });
    var hasEsgModule = computed(function () {
      var _accountResult$value2, _accountResult$value3;
      return (((_accountResult$value2 = accountResult.value) === null || _accountResult$value2 === void 0 ? void 0 : (_accountResult$value3 = _accountResult$value2.getAccount) === null || _accountResult$value3 === void 0 ? void 0 : _accountResult$value3.bookedModules) || []).includes(Module.Esg);
    });
    var _useListReportingRequ = useListReportingRequestsQuery(function () {
        return {
          enabled: hasMetricsModule.value || hasEsgModule.value,
          fetchPolicy: 'network-only'
        };
      }),
      result = _useListReportingRequ.result,
      loading = _useListReportingRequ.loading;

    // Portfolio editors browse company Home with portfolio Account-Id, so the API
    // returns all portfolio requests — keep only those targeting this venture.
    var requests = computed(function () {
      var _result$value$listRep, _result$value;
      return ((_result$value$listRep = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listReportingRequests) !== null && _result$value$listRep !== void 0 ? _result$value$listRep : []).filter(function (request) {
        return ventureRow(request) != null;
      });
    });
    var isLoadingSection = computed(function () {
      return (hasMetricsModule.value || hasEsgModule.value) && loading.value && !result.value;
    });
    var ventureRow = function ventureRow(request) {
      return (request.ventures || []).find(function (row) {
        return String(row.ventureId) === String(ventureId.value);
      });
    };
    var ventureStatus = function ventureStatus(request) {
      var _ventureRow;
      return ((_ventureRow = ventureRow(request)) === null || _ventureRow === void 0 ? void 0 : _ventureRow.status) || 'NOT_STARTED';
    };
    var chipStatus = function chipStatus(request) {
      var status = ventureStatus(request);
      return request.requestType === ReportingRequestType.Esg ? reportingEsgChipStatus(status) : status;
    };
    var ventureProgress = function ventureProgress(request) {
      var _ventureRow2, _ventureRow3, _ventureRow3$metricId, _request$metricIds;
      var summary = (_ventureRow2 = ventureRow(request)) === null || _ventureRow2 === void 0 ? void 0 : _ventureRow2.statusSummary;
      if (summary) return summary;
      var fallbackTotal = ((_ventureRow3 = ventureRow(request)) === null || _ventureRow3 === void 0 ? void 0 : (_ventureRow3$metricId = _ventureRow3.metricIds) === null || _ventureRow3$metricId === void 0 ? void 0 : _ventureRow3$metricId.length) || ((_request$metricIds = request.metricIds) === null || _request$metricIds === void 0 ? void 0 : _request$metricIds.length) || 0;
      return {
        totalKpis: fallbackTotal,
        completedKpis: 0,
        skippedKpis: 0,
        incompleteKpis: fallbackTotal
      };
    };
    var detailLink = function detailLink(request) {
      if (request.requestType === ReportingRequestType.Esg) {
        var _ventureRow4;
        var questionnaireId = (_ventureRow4 = ventureRow(request)) === null || _ventureRow4 === void 0 ? void 0 : _ventureRow4.questionnaireId;
        return questionnaireId ? "/".concat(ventureId.value, "/esg/edit/").concat(questionnaireId) : "/".concat(ventureId.value, "/esg");
      }
      return "/".concat(ventureId.value, "/reporting-request/").concat(request.id);
    };
    var taskGuidance = function taskGuidance(request) {
      return request.requestType === ReportingRequestType.Esg ? proxy.$t('home.taskGuidanceEsg', {
        period: request.referencePeriod
      }) : proxy.$t('home.taskGuidance', {
        period: request.referencePeriod
      });
    };
    var formatDate = function formatDate(value) {
      if (!value) return '—';
      return new Date(value).toLocaleDateString();
    };
    return {
      __sfc: true,
      proxy: proxy,
      ventureId: ventureId,
      accountResult: accountResult,
      hasMetricsModule: hasMetricsModule,
      hasEsgModule: hasEsgModule,
      result: result,
      loading: loading,
      requests: requests,
      isLoadingSection: isLoadingSection,
      ventureRow: ventureRow,
      ventureStatus: ventureStatus,
      chipStatus: chipStatus,
      ventureProgress: ventureProgress,
      detailLink: detailLink,
      taskGuidance: taskGuidance,
      formatDate: formatDate,
      ReportingRequestType: ReportingRequestType
    };
  }
});